import { render, staticRenderFns } from "./InsCmsCat3.vue?vue&type=template&id=847e7c1a&scoped=true&"
import script from "./InsCmsCat3.vue?vue&type=script&lang=ts&"
export * from "./InsCmsCat3.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsCat3.vue?vue&type=style&index=0&id=847e7c1a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847e7c1a",
  null
  
)

export default component.exports